import { EventBus } from '@/helpers/eventBus'
import { createNamespacedHelpers, mapActions } from 'vuex'

const accountController = createNamespacedHelpers('account')

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'payload'
    },
    next_block_id: {
      default: null
    },
    number: {
      type: Number,
      default: 0
    },
    template_connector_id: {
      type: Number,
      default: 0
    },
    block_id: {
      type: Number,
      default: 0
    },
    language_id: {
      type: Number,
      default: 1
    },
    template_id: {
      type: Number,
      default: 0
    },
    element_connector_id: {
      type: Number,
      default: 0
    },
    element_id: {
      type: Number,
      default: 0
    },
    url: {
      type: String,
      default: ''
    },
    element: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: true
    },
    ignored: {
      type: Boolean,
      default: false
    },
    is_extension: {
      type: Boolean,
      default: false
    },
    data: {
      type: String,
      default: ''
    },
    phone: {
      type: String,
      default: ''
    },
    user_attribute_id: {
      default: null
    },
  },
  computed: {
    ...accountController.mapGetters([
      'selectedLanguage',
      'selectedLocale',
      'selectedLanguageName'
    ]),
    connectorId () {
      if (this.element) {
        return `element_connector_${this.element_connector_id}`
      } else {
        return `template_connector_${this.template_connector_id}`
      }
    }
  },
  methods: {
    ...mapActions([
      'template_connector/update',
      'element_connector/update',
      'template_connector/destroy',
      'element_connector/destroy'
    ]),
    updateConnector (blockId, templateId, connector) {
      const self = this
      const route = this.element ? 'element_connector/update' : 'template_connector/update'

      this[route]({
        account_id: self.$route.params.account_id,
        language_id: self.selectedLanguage,
        block_id: blockId,
        template_id: templateId,
        ...connector,
        callback: async (res) => {
          if (res.error) {
            const res = await this.$bvModal.msgBoxConfirm('Ocurrió un error guardando conector. ¿Deseas intentarlo de nuevo?', {
              title: 'Error de guardado',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (res === true) {
              this.updateConnector(...arguments)

              this.$message.success('Actualizado')
            }
          }

          this.$store.commit(
            'block/updateElementConnector',
            {
              block_id: blockId,
              template_id: templateId,
              ...res.resource
            }
          )
        }
      })
    },
    deleteConnector (blockId, templateId, connector) {
      const self = this
      const route = this.element ? 'element_connector/destroy' : 'template_connector/destroy'

      this[route]({
        account_id: self.$route.params.account_id,
        language_id: self.selectedLanguage,
        block_id: blockId,
        template_id: templateId,
        ...connector,
        callback: async (res) => {
          if (res.error) {
            const res = await this.$bvModal.msgBoxConfirm('Ocurrió un error eliminando conector. ¿Deseas intentarlo de nuevo?', {
              title: 'Error de eliminando',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (res === true) this.deleteConnector(...arguments)
          }
        }
      })
    }
  }
}
